<div class='avano-menu' [class.avano-menu-collapsed]='collapsed'>

  <!-- The toggle button is not controlable from the outside -->
  <div class='avano-menu-toggle-container' (click)='toggleMenu()' [attr.title]="!menuTitle?.length ? collapsed ? 'Open menu' : 'Collapse menu' : undefined">
    <i class='avano-menu-toggle' [attr.title]="collapsed && menuTitle ? menuTitle : undefined"></i>
    <span *ngIf="menuTitle" class="avano-menu-title">{{ menuTitle }}</span>
  </div>


  <!-- Main logic is hidden here -->
  <div #avanoMenuItems class='avano-menu-items avano-scrollbars'>
    <ng-container *ngFor="let menuEntry of menuEntries">

      <ng-container
        *ngIf='menuEntry.children; then menuEntryFirstLevelWithChildren; else menuEntryFirstLevel'>
      </ng-container>


      <!-- Just a plain navigation entry on first level -->
      <ng-template #menuEntryFirstLevel>
        <span class='avano-menu-entry' *ngIf="menuEntry.visible !== false">
          <div class='avano-menu-entry-first'
              [routerLink]='menuEntry.routerLink'
              routerLinkActive='avano-menu-entry-selected'
              [routerLinkActiveOptions]='routerLinkActiveOptions'>
            <i class='avano-menu-item-icon' [ngClass]='menuEntry.icon' [title]='collapsed ? (menuEntry.label | translate) : ""'></i>
            <span class='avano-menu-item-label'>{{ menuEntry.label | translate }}</span>
            <span>
            </span>
          </div>
        </span>
      </ng-template>

      <!--
        A navigation entry on first level with children
        The parent entry is not routable currently
      -->
      <ng-template #menuEntryFirstLevelWithChildren>
        <span class='avano-menu-entry-group'
          [class.avano-menu-entry-expanded]='menuEntry.isExpanded'
          *ngIf="menuEntry.visible !== false">
          <div class='avano-menu-entry-first-group'
              routerLinkActive='avano-menu-entry-selected'
              [routerLinkActiveOptions]='routerLinkActiveOptions'>
            <div class='avano-menu-entry-first' (click)='toggleGroup(menuEntry)'>
              <i class='avano-menu-item-icon' [ngClass]='menuEntry.icon' [title]='collapsed ? (menuEntry.label | translate) : ""'></i>
              <span class='avano-menu-item-label'>{{ menuEntry.label | translate }}</span>
              <span class='avano-menu-group-toggler'>
                <i *ngIf='menuEntry.isExpanded' class='icon-content-chevron-up'></i>
                <i *ngIf='!menuEntry.isExpanded' class='icon-content-chevron-down'></i>
              </span>
            </div>
            <div class='avano-menu-entry-first-group-children'>
              <ng-container *ngFor='let menuEntrySecondLevel of menuEntry.children'>
                <div
                  *ngIf="menuEntrySecondLevel.visible !== false"
                  class='avano-menu-entry-second'
                  [routerLink]='menuEntrySecondLevel.routerLink'
                  routerLinkActive='avano-menu-entry-selected'
                >
                  <span class='avano-menu-entry-second-label'>{{ menuEntrySecondLevel.label | translate }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </span>
      </ng-template>
    </ng-container>
  </div>


  <!-- The footer currently only contains a version number/string from the outside -->
  <div class='avano-menu-version' [title]='appVersion ? appVersion : "" '>
    <div class='avano-menu-version-logo'></div>
    <span class='avano-menu-version-text' *ngIf='appVersion'>{{ appVersion }}</span>
  </div>
</div>
